module.exports = __webpack_public_path__ + "img/banner5.21fd3e3c.png";